/**
 * Is ISP Business switched on in this build?
 *
 * 🔴 SHIPPED TO PRODUCTION DELIBERATELY DARK. The work is real but unfinished —
 * no Accounts page, never canaried on a customer's router — and it is going to
 * prod only so the staging box can be handed to another session. Ray,
 * 2026-08-31: *"can we push this to prod but hidden in prodction… make sure our
 * code wont affect destroy the prod since were not finish here."*
 *
 * Off unless the build explicitly says otherwise, which is the right way round
 * for something half-built: a missing variable hides it, a typo hides it, and a
 * new environment hides it.
 *
 * ⚠️ THIS IS THE COSMETIC HALF. The server refuses `/api/isp/*` with a 404
 * unless ISP_ENABLED=true, and that is the half that matters — registering a
 * MikroTik allocates a WireGuard address from the same plane the piso-wifi
 * vendos use. Hiding a menu stops nobody who types a URL.
 */
export const ISP_ENABLED = import.meta.env.VITE_ISP_ENABLED === 'true';
